import { Slice, SliceProps } from 'victory';

interface CustomSliceProps<T> extends SliceProps {
  events?: {
    onMouseOver: (event: MouseEvent) => void;
    onMouseOut: (event: MouseEvent) => void;
  };
  isHighlighted?: (datum: T) => boolean;
}

const CustomSlice = <T,>(props: CustomSliceProps<T>) => {
  const { events } = props;
  const highlight =
    props.isHighlighted && props.datum && props.isHighlighted(props.datum as T);

  const invisibleSliceEventProps = {
    transform: `translate(${props.origin?.x}, ${props.origin?.y})`,
    pointerEvents: 'all',
    style: { ...props.style, fill: 'transparent' },
    events,
  } as unknown as SliceProps;

  const visibleSliceEventProps = {
    transform: `translate(${props.origin?.x}, ${props.origin?.y}) scale(${
      highlight ? 1.05 : 1
    })`,
    pointerEvents: 'none',
    style: { ...props.style, cursor: 'pointer' },
  } as unknown as SliceProps;

  return (
    <g>
      {/* Invisible larger hover area */}
      <Slice {...props} {...invisibleSliceEventProps} />
      {/* Visible slice */}
      <Slice {...props} {...visibleSliceEventProps} />
    </g>
  );
};

export default CustomSlice;
